import {_, React, observer, observable, computed, action, useLocalStore, classNames, Popover2} from '@api'
import {Tooltip2} from '@api'
import {Menu, MenuDivider, MenuItem, Popover} from '@blueprintjs/core'
import {AccessAlarm, AccountCircle, BugReport, DirectionsRun} from '@material-ui/icons'
import {deployments, icons, jira, nav, ui} from '@stores'
import {ContextMenuItem, DevDeploymentsMenuItems, useStores} from '@modules'
import {authStore} from '@utils'
import {JiraIcon, PrimaryIconButton} from 'centric-ui-components'
import * as css from './DevMenuDropdownIcon.css'
import UPDATE_SITE_STORE from './updateSiteStore.graphql'

/// region Store

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const DevMenuDropdownIcon = observer<MyProps>(function DevMenuDropdownIcon({className, ...props}) {
  if (!DEBUG) return null

  const {strings, deployments: {downloadCurrentConfig, uploadConfig, updateDBConfig, selectedDeployment}, dev: {addSshToClipboard}, apollo } = useStores()

  return (
    <div className={classNames(css.root, className)}>
      <Tooltip2 content={strings.devOnly} placement='bottom'>
        <Popover2
        interactionKind='hover'
        className={css.root}
        popoverClassName={css.menuPopover}
        position='bottom-right'
        minimal
        content={<Menu>
          {selectedDeployment && <MenuDivider title={`Deployment:  ${deployments.labelFor(selectedDeployment)}`} /> }
		       <MenuItem icon='dashboard' text='Deployments'>
			       <DevDeploymentsMenuItems/>
		       </MenuItem>
          {selectedDeployment && <MenuItem icon='blank' text={`SSH (Copy to Clipboard)`} target='_blank' onClick={addSshToClipboard}/>}
          <CurrentDeploymentAWSLinks />
         <UpdateServerSiteStoreMenuItem />
          <MenuDivider />
          <ContextMenuItem icon='book' text='Confluence' href={jira.urls.confluence.home} target='_blank' />
          <JiraDevMenuItem />
		       <MenuDivider />
			       <MenuItem icon={'database'}
			                 href={nav.kibanaUrl}
			                 target='_blank'
			                 text={`Open Kibana Dev Tools`}/>
			       <MenuItem icon={nav.queryParams.mobx === null ? 'tick' : 'blank'} onClick={() => nav.updateQueryParams({mobx: nav.queryParams.mobx === null ? undefined : null})}
			                 text='MobX Debug Panel'/>

		       <MenuDivider title='Configuration'/>
		       <ContextMenuItem text='Update Database Configuration' icon='refresh' onClick={updateDBConfig}/>
		       <ContextMenuItem text='Save Configuration' icon='download' onClick={downloadCurrentConfig}/>
		       <ContextMenuItem text='Upload Configuration...' icon='upload' onClick={uploadConfig}/>
          <MenuDivider title='Dev'/>
          <MenuItem  icon='build' text={'Build Pipeline'} target='_blank' href={`https://bitbucket.org/centricsoftware/design-board-ui-2.0/addon/pipelines/home#!/results/branch/${GIT_BRANCH}/page/1`}/>
          <MenuItem icon='git-branch' text={GIT_BRANCH} target='_blank' href={`https://bitbucket.org/centricsoftware/design-board-ui-2.0/branch/${GIT_BRANCH}`}/>
          <MenuItem icon='git-commit' text={`Commit: ${GIT_COMMIT}`} target='_blank' href={`https://bitbucket.org/centricsoftware/design-board-ui-2.0/commits/${GIT_COMMIT}`}/>
        </Menu>}>
          <PrimaryIconButton icon={icons.dev} className={css.devIconButton}/>
      </Popover2>
      </Tooltip2>
    </div>
  )
})

export const JiraDevMenuItem = observer(function JiraDevMenuItem() {
  return <ContextMenuItem icon={<JiraIcon/>} text='Jira' href={jira.urls.jira.home} target='_blank'>
    <ContextMenuItem icon={<AccessAlarm/>} text='My Recent Work' href={jira.urls.jira.myWork} target='_blank'/>
    {/*<ContextMenuItem icon={<AccessAlarm />} text='Recent Changes'/>*/}

    <MenuDivider/>

    <ContextMenuItem icon={<DirectionsRun/>} text='Backlog' href={jira.urls.jira.vip.backlog} target='_blank'/>
    <ContextMenuItem icon={<DirectionsRun/>} text='Sprints' href={jira.urls.jira.vip.activeSprints} target='_blank'>
      <MenuDivider title='Active Sprint' />
      <ContextMenuItem icon={'person'} text='Open and Assigned to Me' href={jira.urls.jira.vip.sprint.active.openAndAssignedToMe} target='_blank'/>
      <MenuDivider />
      <ContextMenuItem icon={'people'} text='In Progress' href={jira.urls.jira.vip.sprint.active.inProgress} target='_blank'/>
      <ContextMenuItem icon={<AccessAlarm/>} text='Not Closed' href={jira.urls.jira.vip.sprint.active.notClosed} target='_blank'/>
      <ContextMenuItem icon={'blank'} text='Ready for QA' href={jira.urls.jira.vip.sprint.active.readyForQa} target='_blank'/>
      <ContextMenuItem icon={'blank'} text='Bugs' href={jira.urls.jira.vip.sprint.active.bugs} target='_blank'/>
      <ContextMenuItem icon={'blank'} text='Stories' href={jira.urls.jira.vip.sprint.active.stories} target='_blank'/>
    </ContextMenuItem>

    <MenuDivider title='Issues'/>
    <ContextMenuItem icon={'plus'} text='New Issue'>
    </ContextMenuItem>
    <ContextMenuItem icon={<BugReport/>} text='Assigned to Me'>
    </ContextMenuItem>
    <ContextMenuItem icon={'blank'} text='More...'>
    </ContextMenuItem>
  </ContextMenuItem>
})
/// endregion


export const UpdateServerSiteStoreMenuItem = observer(function UpdateServerSiteStoreMenuItem() {
    const {apollo} = useStores()

    return (authStore.userIsAuthenticated && <ContextMenuItem icon='clean' text={`graphQLServer - updateSiteStore()`} onClick={() => apollo.client.mutate({mutation: UPDATE_SITE_STORE})}/>)
})

export const CurrentDeploymentAWSLinks = observer(function CurrentDeploymentAWSLinks() {
    const {aws} = useStores()

  if (!aws?.cloudConfig) return null

  const {cloudConfig: {s3, bucket}} = aws

    return (<ContextMenuItem icon='cloud' text='AWS Links'>
      <ContextMenuItem icon='database' text='S3' target='_blank'
                       href={`https://s3.console.aws.amazon.com/s3/buckets/${bucket}?prefix=assets/images/&showversions=false`} />
    </ContextMenuItem>)
})
//https://s3.console.aws.amazon.com/s3/buckets/vip-dev?region=us-west-2&prefix=assets/images/&showversions=false


// WEBPACK FOOTER //
// ./src/modules/dev/DevMenuDropdownIcon.tsx